import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Get session_id from URL hash
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error('No session_id found in URL');
        navigate('/login');
        return;
      }

      const sessionId = sessionIdMatch[1];
      const role = searchParams.get('role') || 'user';

      try {
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId, role },
          { withCredentials: true }
        );

        setUser(response.data);

        // Clear the hash from URL
        window.history.replaceState(null, '', window.location.pathname);

        // Redirect based on role
        if (response.data.role === 'agency') {
          navigate('/agency/dashboard', { state: { user: response.data } });
        } else {
          navigate('/dashboard', { state: { user: response.data } });
        }
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/login');
      }
    };

    processSession();
  }, [navigate, searchParams, setUser]);

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-slate-900 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-slate-600">Completing login...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
